import { fetchData } from './users'
import md5 from 'md5'

let Base_url = process.env.BASE_URL

export const removeService = async (serviceID, username) => {
  let Endpoint = `${Base_url}/remove-service` // // Replace with environment variables

  try {
    let result = await fetchData(Endpoint, { serviceID, username })
    // console.log(result)
    return result
  } catch (error) {
    console.log(error)
  }
}

export const changeDisplayName = async (
  serviceID,
  name,
  username,
  setDefault
) => {
  let Endpoint = `${Base_url}/edit-account` // // Replace with environment variables

  try {
    let result = await fetchData(Endpoint, {
      serviceID,
      name,
      username,
      setDefault
    })
    // console.log(result)
    return result
  } catch (error) {
    console.log(error)
  }
}

export const AddService = async (
  serviceType,
  primaryID,
  secondaryID,
  username
) => {
  let Endpoint = `${Base_url}/add-service` // // Replace with environment variables

  try {
    let result = await fetchData(Endpoint, {
      serviceType,
      primaryID,
      secondaryID,
      username
    })
    // console.log(result)
    return result
  } catch (error) {
    console.log(error)
  }
}

export const AddServiceVerification = async (serviceID, code, username) => {
  let Endpoint = `${Base_url}/verify-service` // // Replace with environment variables

  try {
    let result = await fetchData(Endpoint, { serviceID, code, username })
    // console.log(result)
    return result
  } catch (error) {
    console.log(error)
  }
}

export const ChangePassword = async (
  oldPassword,
  newPassword,
  confirmPassword,
  username
) => {
  let Endpoint = `${Base_url}/reset-pass` // // Replace with environment variables
  let hashedOldPassword = md5(oldPassword)
  let hashedNewPassword = md5(newPassword)
  let hashedConfirmPassword = md5(confirmPassword)
  try {
    let result = await fetchData(Endpoint, {
      hashedOldPassword,
      hashedNewPassword,
      hashedConfirmPassword,
      username
    })
    // console.log(result)
    return result
  } catch (error) {
    console.log(error)
  }
}

export const GetAllServices = async username => {
  let Endpoint = `${Base_url}/get-all-services` // // Replace with environment variables

  try {
    let result = await fetchData(Endpoint, { username })
    // console.log(result)
    return result
  } catch (error) {
    console.log(error)
  }
}

export const updateDefaultService = async (username, serviceID) => {
  let Endpoint = `${Base_url}/set-default-service`

  try {
    let result = await fetchData(Endpoint, { username, serviceID })
    // console.log(result)
    return result
  } catch (error) {
    console.log(error)
    return false
  }
}
